import { useLocalization } from '@/services/localizationService';

export default function OtherPlansCaption() {
  const { t, data } = useLocalization();
  return t(data.onboarding.searchingForIdealPlan, {
    bold: (text) => <span className="B16">{text}</span>,
  });
}
